var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.387 13.301l-1.44-1.435c-2.388 1.144-5.236.659-7.11-1.21C-.039 8.787-.532 5.94.605 3.55l1.959 1.954c.523.535 1.294.749 2.018.559.725-.19 1.291-.755 1.483-1.48.193-.723-.019-1.494-.553-2.02L3.555.612c2.386-1.14 5.232-.655 7.105 1.213 1.873 1.868 2.366 4.713 1.23 7.102l1.334 1.33M20.029 17.033l1.955 1.95c2.386-1.143 5.234-.658 7.108 1.21.413.411.76.871 1.036 1.363.066.117-2.609 2.438-4.163 4.415-1.657 2.108-2.592 4.738-2.7 4.713-1.107-.258-2.15-.819-2.993-1.66-1.873-1.868-2.366-4.713-1.232-7.102l-1.955-1.95M.952 30.046h0c-.58-.576-.905-1.36-.905-2.177 0-.818.326-1.601.905-2.178l6.456-6.443c.402-.401 1.053-.401 1.456 0l2.912 2.903c.193.192.301.453.301.726 0 .272-.108.533-.3.726l-6.458 6.443c-1.207 1.202-3.16 1.202-4.367 0zM21.771.604l8.554 8.525c.386.385.603.907.603 1.452 0 .545-.217 1.067-.603 1.451l-2.911 2.905c-.805.803-2.107.803-2.912 0l-8.554-8.525c-.386-.384-.603-.906-.603-1.45 0-.546.217-1.068.603-1.452l2.91-2.903c.805-.803 2.107-.804 2.913-.003zM20.315 10.764L10.183 20.563",
    transform: "translate(8 8) translate(.035 .029)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.fb18eead2713228aa9816b31c634559f.svg";
export { ForwardRef as ReactComponent };